import { FETCH_CATTLEDETAIL_FAILURE, FETCH_CATTLEDETAIL_REQUEST, FETCH_CATTLEDETAIL_SUCCESS, FETCH_REQUEST_CATTLEDETAIL_SUCCESS, FETCH_REQUEST_CATTLEDETAIL_FAILURE } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const cattleDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CATTLEDETAIL_REQUEST:
            return {
                ...state,
            }
        case FETCH_CATTLEDETAIL_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_CATTLEDETAIL_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        case FETCH_REQUEST_CATTLEDETAIL_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_REQUEST_CATTLEDETAIL_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}